import { render, staticRenderFns } from "./submissions.vue?vue&type=template&id=13ac17d2&scoped=true"
import script from "./submissions.vue?vue&type=script&lang=js"
export * from "./submissions.vue?vue&type=script&lang=js"
import style0 from "./submissions.vue?vue&type=style&index=0&id=13ac17d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac17d2",
  null
  
)

/* custom blocks */
import block0 from "./submissions.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports